<div class="d-block mb-2">
  <div class="dropdown" on:click="{() => show = !show}" use:clickOutside on:click_outside={handleClickOutside}>
      <button
      class="btn btn-primary dropdown-toggle d-lg-none ml-2" 
      type="button"
      id="weatherLocationSelector"
      data-toggle="dropdown"
      aria-expanded="false"
    >
    <span class="icon-location mr-2"></span>
    <span style="font-weight: bold;"> {$selectedCity.city} </span>
  </button>
      <button
      class="btn btn-primary dropdown-toggle d-none d-lg-block"
      type="button"
      id="weatherLocationSelector"
      data-toggle="dropdown"
      aria-expanded="false"
      style="background-color: rgba(0, 0, 0, 0.3);"
    >
    <span class="icon-location mr-2"></span>
    <span style="font-weight: bold;"> {$selectedCity.city} </span>
  </button>
  


    <div
      class="dropdown-menu" 
      class:show="{show}" 
      aria-labelledby="weatherLocationSelector"
      style="right: unset; left: 0;"
    >
    
      {#each $weatherData as city}
        <a class="dropdown-item " href="javascript:void(0)"  on:click="{() => cityOptions.changeCity(city.city, true)}">{city.city}</a>
      {/each}
    </div>
  </div>
</div>

<script lang="ts">
  import { get } from "svelte/store";
  import {clickOutside} from '../services/clickOutside.js';
  import { cityOptions } from "../services/CityOptions";
  import { weatherStore } from "../store";
  const {weatherData, selectedCity } = weatherStore;
  let show = false
  function handleClickOutside(event) {
		show = false
	}
</script>
